import type { App } from 'vue';
import type { ArcoOptions } from '../_utils/types';
import { setGlobalConfig, getComponentPrefix } from '../_utils/global-config';
import _Diff from './diff';

const Diff = Object.assign(_Diff, {
  install: (app: App, options?: ArcoOptions) => {
    setGlobalConfig(app, options);
    const componentPrefix = getComponentPrefix(options);

    app.component(componentPrefix + _Diff.name, _Diff);
  },
});

export type DiffInstance = InstanceType<typeof _Diff>;

export default Diff;
